import type CalendarModuleCommand from '../store/schema/CalendarModuleCommands';
import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
import { onRequestModuleCommand, onResetModuleCommand } from './onRequestModuleCommandActions';
import { trace } from 'owa-trace';

/**
 * Updates module command
 * @param {CalendarModuleCommand} moduleCommand module command to request
 */
export let requestModuleCommand = action('requestModuleCommand')(function requestModuleCommand(
    moduleCommand: CalendarModuleCommand,
    formId?: string
): void {
    trace.info(`module command being changed from ${store.moduleCommand} to ${moduleCommand}`);
    // Open_FullComposeForm (double click callback) should take precedence over Open_QuickCompose (single click callback)
    if (!(store.moduleCommand == 'Open_FullComposeForm' && moduleCommand == 'Open_QuickCompose')) {
        store.moduleCommand = moduleCommand;
        store.formId = formId ?? null;
        onRequestModuleCommand(moduleCommand);
    }

    trace.info(`module command is now ${store.moduleCommand}`);
});

export function resetModuleCommand(command: CalendarModuleCommand) {
    if (store.moduleCommand == command) {
        requestModuleCommand(null /* None */);
        onResetModuleCommand();
    }
}
